import React from "react";

const InstagramIcon = () => {
  return (
    <svg
      width={30}
      height={30}
      viewBox="0 0 199.98 199.97"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="a" transform="translate(0)">
          <rect fill="none" width="199.98" height="199.97" />
        </clipPath>
      </defs>
      <g data-name="Layer 2">
        <g clipPath="url(#a)">
          <g opacity={0.8}>
            <path
              fill="#326699"
              transform="translate(0)"
              d="M200,169.59A30.39,30.39,0,0,1,169.59,200H30.39A30.39,30.39,0,0,1,0,169.59V30.39A30.39,30.39,0,0,1,30.39,0h139.2A30.39,30.39,0,0,1,200,30.39Z"
            />
          </g>
        </g>
        <path
          fill="#ffeed7"
          transform="translate(0)"
          d="M101.47,79.6c-12.9,0-23.36,10.13-23.36,22.64s10.46,22.63,23.36,22.63,23.36-10.14,23.36-22.63S114.37,79.6,101.47,79.6m44.9,13.91H136.13a34,34,0,0,1,1.5,10c0,19.34-16.19,35-36.16,35s-36.16-15.68-36.16-35a34.17,34.17,0,0,1,1.5-10H56.14v49.13a4.62,4.62,0,0,0,4.62,4.61h81a4.62,4.62,0,0,0,4.62-4.61ZM127.94,57.24a5.26,5.26,0,0,0-5.24,5.25V75a5.25,5.25,0,0,0,5.24,5.24h13.14A5.25,5.25,0,0,0,146.32,75V62.49a5.26,5.26,0,0,0-5.24-5.25ZM58.14,44.33h86.45a15,15,0,0,1,14.93,14.93v86.45a15,15,0,0,1-14.93,14.92H58.14a15,15,0,0,1-14.93-14.92V59.26A15,15,0,0,1,58.14,44.33"
        />
      </g>
    </svg>
  );
};
export default InstagramIcon;
